import { catchError, map, switchMap, take } from 'rxjs/operators';
import { OrderBuilderState } from './../../../../../reducers/index';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  JobsiteLoadAction,
  JobsiteLoadCompleteAction,
  JobsiteLoadFailAction,
  LS_LOAD,
  LS_SALES_AREA_LOAD,
  SalesAreaLoadAction,
  SalesAreaLoadCompleteAction,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { JobsiteLoaderService } from '../../../services/loaders/jobsite.loader.service';
import { IRequestJobsitesResponse } from '../../../models/order-management/jobsite.model';
import { IMyProductRequest } from '../../../models/order-management/product.model';
import { IJobsiteSalesAreaResponse } from '../../../models/order-management/jobsite-sales-area.model';
import { ProductLoaderService } from '../../../services/loaders/product.loader.service';
import * as fromAdditionalServicesAction from '@ordersnproducts/modules/order-builder/modules/location-specification/actions/additional-services.action';

import { JobsiteBlockedService } from '@cemex-core/cmx-api';

/**
 * An effect which monitors the actions$ Observable for (job-site) LOAD operations
 * and then
 */
@Injectable()
export class JobsiteLoadLocSpecEffects implements IEffect {
  jobsiteLoadWithBlocked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD),
      switchMap((action: JobsiteLoadAction) => {
        return this.blockedJobsiteLoaderService.getJobsites(action.payload).pipe(
          map((response: any) => {
            response = response as IRequestJobsitesResponse;
            return new JobsiteLoadCompleteAction(response);
          }),
          catchError((error) => of(new JobsiteLoadFailAction(error))),
        );
      }),
    ),
  );

  jobsiteSalesAreaLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_SALES_AREA_LOAD),
      switchMap((action: SalesAreaLoadAction) => {
        return this.jobsiteLoaderService
          .getJobsiteSalesAreas(action.payload.productlineId, action.payload.shipmentlocationId)
          .pipe(
            map((salesAreaResponse: IJobsiteSalesAreaResponse) => {
              if (salesAreaResponse.count > 0) {
                const request: IMyProductRequest = {
                  salesDocumentTypeCode: 'Z',
                  productLineId: action.payload.productlineId,
                  shippingConditionId: action.payload.shippingConditionId,
                  salesAreaId: salesAreaResponse.jobsiteSalesAreas[0].salesArea.salesAreaId,
                  jobsiteId: action.payload.shipmentlocationId.toString() + '.2',
                };

                this.productLoaderService
                  .getMyProductsV3(request)
                  .pipe(
                    take(1),
                    catchError((error) => of(new JobsiteLoadFailAction(error))),
                  )
                  .subscribe((response: any) => {
                    if (response.products.length > 0) {
                      this.store.dispatch(
                        new fromAdditionalServicesAction.AddAdditionalServices({
                          additionalServices: response.products,
                        }),
                      );
                    }
                  });
              }
              return new SalesAreaLoadCompleteAction({
                salesAreas: salesAreaResponse,
                productlineId: action.payload.productlineId,
                shipmentlocationId: action.payload.shipmentlocationId,
                shippingConditionId: action.payload.shippingConditionId,
              });
              // return new JobsiteLoadCompleteAction(shipmentLocationResponse);
            }),
            catchError((error) => of(new JobsiteLoadFailAction(error))),
          );
      }),
    ),
  );

  /**
   *
   * @param {Store<OrderBuilderState>} store the usual in-memory store of application state.
   * @param {Actions} actions$ an Observable subclass which deals with actions
   *                           taken by or in the application
   * @param {ShipmentLocationsService} shipmentLocationService
   */
  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private jobsiteLoaderService: JobsiteLoaderService,
    private productLoaderService: ProductLoaderService,
    private blockedJobsiteLoaderService: JobsiteBlockedService,
  ) {}
}
